export { Avatar, StyledAvatar } from './Avatar';
